import React from "react";
import { Box, Typography, Button } from "@mui/material";
import projectStyle from "../projectStyle";

//Project cards in project section
const ProjectCard = ({ project, toggleDetails }) => {
  const classes = projectStyle();

  const handleClick = () => {
    if (toggleDetails) {
      toggleDetails();
    } else if (project.link) {
      window.open(project.link, "_blank");
    }
  };

  return (
    <Box className={classes.card} onClick={handleClick} style={{ cursor: "pointer" }}>
      <Box
        className={classes.image}
        style={{ backgroundImage: `url(${project.image})` }}
      />
      <Box className={classes.content}>
        <img src={project.icon} alt={`${project.title} icon`} className={classes.icon} />
        <Typography variant="h6" className={classes.title}>
          {project.title}
        </Typography>
        <Typography variant="body2" className={classes.description}>
          {project.description}
        </Typography>
        <Button href={project.link} className={classes.linkButton}>
          Find more...
        </Button>
      </Box>
    </Box>
  );
};

export default ProjectCard;
